import { useEffect, useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import {
  Collapse,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
} from '@mui/material';
import { Subtype } from '../../types/ServiceAccordion.type';
import {
  CourseLevel,
  SuccessResponse,
} from '../../types/CourseStageAccordion.type';
import { apiGet } from '../../utils/apiClient';
import CourseLevelList from './CourseLevelList';
import TreeBranch from '../common/TreeBranch';

interface CourseTypeCardProps {
  courseType: Subtype;
  fetchCourses: () => void;
}

const CourseTypeCard: React.FC<CourseTypeCardProps> = ({
  courseType,
  fetchCourses,
}) => {
  const [open, setOpen] = useState(false);
  const [levels, setLevels] = useState<CourseLevel[]>([]);

  const handleToggle = () => {
    setOpen(!open);
  };

  const fetchCourseLevels = async () => {
    const res = await apiGet<SuccessResponse>(
      `/course/get-stages/${courseType.id}`,
    );
    setLevels(res.data);
  };

  useEffect(() => {
    if (levels.length === 0) fetchCourseLevels();
  }, [courseType]);

  return (
    <>
      <ListItem
        disablePadding
        sx={{
          mb: 2,
          backgroundColor: 'background.paper',
          borderRadius: 1,
          boxShadow: 1,
          '&:hover': {
            backgroundColor: 'action.hover',
          },
        }}
      >
        <ListItemButton onClick={handleToggle} dense>
          <ListItemText
            primary={
              <Typography variant="h6" component="div" fontWeight="bold">
                {courseType.name}
              </Typography>
            }
          />
          {open ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
        </ListItemButton>
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <TreeBranch>
          <CourseLevelList
            courseType={courseType}
            levels={levels}
            fetchCourses={fetchCourses}
          />
        </TreeBranch>
      </Collapse>
    </>
  );
};

export default CourseTypeCard;
